import React from 'react';
import styled from 'styled-components';
import { Fade } from 'react-awesome-reveal';
import LeaveCommentForm from './LeaveCommentForm';

// --- STYLED COMPONENTS ---

const ArticleContainer = styled.article`
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  max-width: 900px;
  margin: 0 auto;
//   padding: 10px 20px;
  color: #333333;
  line-height: 1.6;
`;

const ContentCard = styled.div`
  background-color: #ffffff;
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);

  @media (max-width: 640px) {
    padding: 20px;
  }
`;

const Title = styled.h1`
  font-size: 2.4rem;
  font-weight: 700;
  color: #439E6D; /* Deep corporate navy blue */
  text-transform: uppercase;
//   margin: 0 0 15px 0;
  letter-spacing: -0.5px;

  @media (max-width: 640px) {
    font-size: 1.8rem;
  }
`;

const MetaInfo = styled.div`
  font-size: 1.1rem;
  font-weight: 600;
  color: #439E6D; /* Your signature theme color */
//   margin-bottom: 35px;
  
  span {
    color: #64748b;
    font-weight: normal;
  }
`;

const IntroText = styled.p`
  font-size: 1.1rem;
  color: #334155;
//   margin-bottom: 30px;
`;

const BulletList = styled.ul`
  list-style-type: none;
  padding-left: 0;
  margin: 0;
`;

const BulletItem = styled.li`
  font-size: 1.1rem;
  color: #4a5568;
//   margin-bottom: 16px;
  position: relative;
  padding-left: 28px;
  line-height: 1.5;

  &::before {
    content: "•";
    color: #0c2340; /* Matches the dark navy header typography accent */
    font-weight: bold;
    font-size: 1.5rem;
    position: absolute;
    left: 6px;
    top: -4px;
  }
`;

// --- MAIN COMPONENT ---

const OnshoreSurveysArticle = () => {
  return (
    <ArticleContainer>
      <Fade triggerOnce direction="up" duration={800}>
        <ContentCard>
          
          {/* Header Typography */}
          <Title>ONSHORE SURVEYS</Title>
          <MetaInfo>
            By admin <span>/ May 13, 2024</span>
          </MetaInfo>

          {/* Section Introduction */}
          <IntroText>
            We have a dedicated team for land surveys and the range services include
          </IntroText>

          {/* Core Service Bullet Points */}
          <BulletList>
            <Fade triggerOnce cascade direction="up" duration={500} fraction={0.1} damping={0.08}>
              <BulletItem>Location sites and routes surveys</BulletItem>
              <BulletItem>Topographical mapping</BulletItem>
              <BulletItem>Cadastral survey and mapping of land parcels boundaries as required by clients</BulletItem>
              <BulletItem>As-built surveys of existing sites/facilities for update and planning.</BulletItem>
              <BulletItem>Geodetic Survey for Control establishment and extension by GPS.</BulletItem>
              <BulletItem>Pollution surveys for remediation exercises and settlement of the associated claims</BulletItem>
              <BulletItem>Onshore Geotechnics.</BulletItem>
              <BulletItem>Structural dynamic monitoring/Subsidence surveys</BulletItem>
              <BulletItem>Hydrographic surveys within the inland waterways</BulletItem>
            </Fade>
          </BulletList>

        </ContentCard>
      </Fade>
      <LeaveCommentForm/>
    </ArticleContainer>
  );
};

export default OnshoreSurveysArticle;